import {
  Announcement03,
  Hand,
  SlashCircle02,
  Truck01,
  Users01,
  UserX01,
  VideoRecorder,
  VideoRecorderOff,
} from "@untitledui/icons";
import type { FC } from "react";
import type { UnboxTableEmptyState } from "@/components/application/table/unbox-table.types";
import type { CreatorStatusTab } from "./collaboration-table-columns";

type IconComponent = FC<{ className?: string }>;

export type EmptyStateConfig = {
  title: string;
  description: string;
  icon: IconComponent;
  action?: {
    label: string;
    icon?: IconComponent;
    href?: string;
  };
};

export const CREATOR_TAB_EMPTY_STATES: Record<CreatorStatusTab, EmptyStateConfig> = {
  all: {
    title: "No creators added yet",
    description: "Invite your first creator to get this collaboration started.",
    icon: Announcement03,
  },
  invited: {
    title: "No Pending Invites",
    description: "Anyone you are awaiting a response to their invite will appear here.",
    icon: Announcement03,
  },
  sample_requested: {
    title: "No Sample Requests",
    description: "As creators request samples, they'll appear here for you to action.",
    icon: Hand,
  },
  sample_status: {
    title: "No Samples in Progress",
    description: "Samples will appear here once they've been approved and are on their way.",
    icon: Truck01,
  },
  pending_post: {
    title: "No Pending Posts",
    description:
      "All creators have either fulfilled their posting requirements or are still within their posting window.",
    icon: VideoRecorderOff,
  },
  posted_video: {
    title: "No GMV Generated Yet",
    description: "None of your creators have made sales. Encourage them to create content to drive revenue.",
    icon: VideoRecorder,
    action: {
      label: "View creators",
      icon: Users01,
      href: "/creator-explorer",
    },
  },
  generated_gmv: {
    title: "No GMV Generated Yet",
    description: "None of your creators have made sales. Encourage them to create content to drive revenue.",
    icon: VideoRecorder,
  },
  posted_no_gmv: {
    title: "No Creators Posted Without Sales",
    description: "Creators who have posted content but haven't generated any sales will appear here.",
    icon: VideoRecorder,
  },
  cancelled: {
    title: "No Cancelled Creators",
    description: "Any cancellations or expired agreements will appear here.",
    icon: SlashCircle02,
  },
  removed: {
    title: "No Removed Creators",
    description: "Creators removed from this collaboration will appear here.",
    icon: UserX01,
  },
};

export const OPEN_ALL_EMPTY_STATE: EmptyStateConfig = {
  title: "No creators have joined yet",
  description: "Any creator on TikTok can pick up this collaboration. The ones who do will appear here.",
  icon: Announcement03,
};

export const TARGET_COLLABORATION_LIST_EMPTY_STATE: UnboxTableEmptyState = {
  title: "Create a collaboration to start selling with target creators",
  description: "Create a target collaboration to invite specific creators to sell your products.",
  icon: Announcement03,
};
